import Markdown, { type Components } from "react-markdown";
import remarkGfm from "remark-gfm";

import { TktlReference } from "src/base-components/Chat/PromptBox/ReferenceRenderer";
import {
  REFERENCE_ELEMENT_TAG,
  remarkReference,
} from "src/base-components/Chat/PromptBox/remarkReference";

const remarkPlugins = [remarkGfm, remarkReference];

const components = {
  [REFERENCE_ELEMENT_TAG]: TktlReference,
} as Components;

type ChatMarkdownRendererProps = {
  content: string;
  dataLoc?: string;
};

export const ChatMarkdownRenderer: React.FC<ChatMarkdownRendererProps> = ({
  content,
  dataLoc,
}) => (
  <div
    className="tktl-markdown break-words font-inter-normal-12px text-gray-800"
    data-loc={dataLoc}
  >
    <Markdown components={components} remarkPlugins={remarkPlugins}>
      {content}
    </Markdown>
  </div>
);
